export default "__VITE_ASSET__C9Lm8Lel__"